module.exports = __webpack_public_path__ + "img/dataservice_gzjg.174246e6.png";